import "./searchBox.css";
import { CustomButton } from "../customButton/CustomButton";
import CustomInput from "../customInput/CustomInput";
import hero from "../../img/hero-bg.svg";

const SearchBox = ({
  setSearchValue,
  onSubmit,
  validationError,
  setValidationError,
}) => {
  const searchHandleChange = (e) => {
    setValidationError(false);
    setSearchValue(e.target.value);
  };

  return (
    <div
      style={{
        backgroundColor: "#EAECE2",
        width: "100%",
        height: "373px",
        backgroundImage: `url(${hero})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right bottom",
        backgroundSize: "300px auto",
        paddingTop: "48px",
        paddingLeft: "80px",
      }}
    >
      <h1
        style={{
        fontFamily: "var(--font-family-base)",
        fontSize: "clamp(1.5rem, 5vw, 2.5rem)", 
        color: "var(--color-primary)",
        wordBreak: "break-word",
        overflowWrap: "anywhere"
      }}
      >
        Välitysliikerekisteri
      </h1>

      <p className="body-lg">
        Lupa- ja valvontaviraston ylläpitämä rekisteri
        kiinteistönvälitysliikkeistä ja
        <br /> vuokrahuoneistojen välitysliikkeistä
      </p>
      <CustomInput
        placeholder="Hae antamalla koko y-tunnus (muodossa 1234567-8)"
        style={{ width: "467px" }}
        onChange={searchHandleChange}
        validationError={validationError}
      />
      <CustomButton className="button primary" onClick={() => onSubmit()}>
        Hae
      </CustomButton>
    </div>
  );
};

export default SearchBox;
